<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">{{$t('apiDoc.在线文档')}}</span>
      <!-- 测试工具已屏蔽
      <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{$t('apiDoc.测试工具')}}</span>
      -->
    </div>
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 测试工具已屏蔽
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    -->
  </div>
</template>
<script>
import onlineDoc from "../components/onlineDoc";
// import apiTestDoc from "../components/apiTestDoc";
import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'customs/addFlight';
export default {
  components: { onlineDoc },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,
      onlineData: {
        apiDesc: `${this.$t('customsDoc.addFlightDesc')}`,
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList: [
          { title: `${this.$t('onlineDoc.Headers')}`, value: [
              {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
              {name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`},
              {name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`},
          ]},
          { title: `${this.$t('onlineDoc.请求参数')}`, value: [
              {name: "bizContent", type: "String", require: "Y", normal: `${this.$t('onlineDoc.业务参数')}`, describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`},
          ]},
          { title: `${this.$t('onlineDoc.业务参数')}`, value: [
              {name: "digest", type: "String", require: "Y", normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`, describe: `${this.$t('customsDoc.digestDesc')}`},
              {name: "departPortCode", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.departPortCode')}`},
              {name: "arrivePortCode", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.arrivePortCode')}`},
              {name: "estimatedTransitTime", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.estimatedTransitTime')}`},
              {name: "estimatedArrivalTime", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.estimatedArrivalTime')}`},
              {name: "flightNo", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.flightNo')}`},
              {name: "masterWaybillNo", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.masterWaybillNo')}`},
              {name: "totalPackage", type: "Number", require: "Y", normal: "", describe: `${this.$t('customsDoc.totalPackage')}`},
              {name: "totalWeight", type: "Number", require: "Y", normal: "", describe: `${this.$t('customsDoc.totalWeight')}`},
              {name: "waybillNos", type: "Array", require: "Y", normal: "", describe: `${this.$t('customsDoc.waybillNos')}`},
          ]}
        ],
        responseDataList: [
          { title: `${this.$t('onlineDoc.响应参数')}`, value: [
              {name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}`},
              {name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}`},
              {name: "data", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务数据')}`},
          ]}
        ],
        requestCode: `{
    "arrivePortCode": "GRU",
    "customerCode": "J0086025574",
    "departPortCode": "MIA",
    "digest": "fWpe+cDsjlIPGONgpQtjKA==",
    "estimatedArrivalTime": "2025-01-13T00:10:01-03:00",
    "estimatedTransitTime": "2025-01-10T00:00:01-03:00",
    "flightNo": "MU456",
    "masterWaybillNo": "TD-2025-0113004",
    "totalPackage": 3,
    "totalWeight": 111.99,
    "waybillNos": ["U88000136538913","U88000133663813","U88000135323749"]
}`,
        responseCode: { "code": "1", "msg": "success", "data": false },
        errcodeJson: []
      },
      // apiTestData 已屏蔽
      // apiTestData: { ... }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>@import "../../css/apiTest.scss";</style>